import { useLocation, useNavigate, useSearchParams, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import LoadingPage from "../../components/Loading";
import { fetchEmailTemplateById, updateEmailTemplateById, sendEmailTemplate } from "../../services/emailTemplates";
import RefreshButton from '../../svgs/RefreshButton'
import SaveButton from '../../svgs/SaveButton'
import DropdownMenu from './components/Dropdown'
import ContentEditor from './components/EmailContentEditor'
import _ from 'lodash'
import { validateEmail } from '../../utils/util'

const TABS = ['合作夥伴管理', '生活服務',
    //'生活服務-優惠券', 
    '生活服務預覽', 'T.Shop', 'T.Shop 商品', 'T.Shop預覽', '關於我們', '條款及細則', '管理員', '財務報告', '商品退款管理', '貼文管理'];

function Page(props) {
    const navigate = useNavigate();
    const { id } = useParams();
    const location = useLocation();
    const navigateTo = (str) => () => {
        navigate(str)
    }
    const [isloading, setIsloading] = useState(false)
    const [searchParams, setSearchParams] = useSearchParams();

    const [data, setData] = useState({})
    useEffect(() => {
        fetchData()
    }, [props.token])

    async function fetchData() {
        let res = await fetchEmailTemplateById(props.token?.token, id)
        if (res.result) {
            setData(res.result)
        }
    }
    const refresh = async () => {
        fetchData()
    }



    const save = async () => {
        if (!data.name || data.name.length < 3) {
            alert('合作夥伴名稱長度需大於3')
            return
        }
        setIsloading(true)
        let res = await updateEmailTemplateById(props.token?.token, data?._id, data?.emailContents || [], data?.title, data?.name)
        if (res.errno) {
            alert(res.message || '更新失敗')
        } else {
            alert('更新成功')
            refresh()
        }
        setIsloading(false);
    }




    return (
        <div className="relative h-full w-full flex flex-col items-start justify-start bg-[#ddd] pb-[16px] gap-[16px]" style={{ overflowY: 'auto' }}>

            <div className='p-[16px] relative rounded-[7px] w-full p-[16px] z-[2] flex flex-row'>
                <div className="flex flex-col z-[2]">
                    <div className="font-[700] text-[24px]">電子郵件模板名稱:{data.name}</div>

                </div>
                <div className="flex flex-row  flex-1 items-center justify-end gap-[8px] z-[2]">
                    <div onClick={save} className="cursor-pointer hover:opacity-[.5]">
                        <SaveButton />
                    </div>
                    <div onClick={refresh} className="cursor-pointer hover:opacity-[.5]">
                        <RefreshButton />
                    </div>

                </div>
                <div className="absolute w-full bottom-0 left-0 right-0 top-0" style={{ background: 'linear-gradient(180deg, rgba(255, 255, 255, 0) 69%, rgba(255, 255, 255, 0.6) 87.5%, #FFFFFF 100%)', zIndex: 1 }} />
            </div>

            <div className="flex flex-row w-full gap-[16px] px-[16px]">
                <div className="flex-1 flex flex-col gap-[8px] max-w-[300px] min-w-[300px] justify-start mt-[8px]">
                    <div className='font-[700]'>電子郵件模板名稱</div>
                    <input value={data?.name || ''} onChange={(e) => { setData({ ...data, name: e.target.value }) }} placeholder='電子郵件模板名稱' className='rounded-[7px] px-[8px] py-[4px] font-[400]' />
                </div>
                <div className="flex-1 flex flex-col gap-[8px] max-w-[300px] min-w-[300px] justify-start mt-[8px]">
                    <div className='font-[700]'>電子郵件標題</div>
                    <input value={data?.title || ''} onChange={(e) => { setData({ ...data, title: e.target.value }) }} placeholder='電子郵件標題' className='rounded-[7px] px-[8px] py-[4px] font-[400]' />
                </div>
            </div>

            <EmailContent data={data} refresh={refresh} onEdit={(key, value) => { setData({ ...data, [key]: value }) }} token={props.token?.token} />






            {isloading && <LoadingPage />}
        </div>
    )
}


export default connect((store) => {
    return {
        token: store.tokenReducer,
        control: store.controlReducer,
    }
})(Page)




function EmailContent(props) {
    const [isloading, setisloading] = useState(false);
    const data = props.data


    {/*content handler*/ }
    const handleContentOrder = (oldLayout, newLayout) => {
        let array = []
        newLayout.sort((a, b) => { if (a.y < b.y) { return -1; } else if (b.y < a.y) { return 1; } return 0; })
        for (let i of newLayout) {
            let oldIndex = _.findIndex(oldLayout, { 'i': i.i });
            array.push(data?.emailContents?.[oldIndex]);
        }
        if (props.onEdit) {
            props.onEdit('emailContents', array)
        }

    }
    const handleAddContent = () => {
        let c = [...(data?.emailContents || [])]
        c.push({ id: Date.now(), type: '電郵內容', content: '', isTitle: false })
        if (props.onEdit) {
            props.onEdit('emailContents', c)
        }
    }
    const handleSectionDeleteContent = (card, cardIndex) => {
        let c = [...(data?.emailContents || [])];
        c.splice(cardIndex, 1);
        if (props.onEdit) {
            props.onEdit('emailContents', c)
        }
    }
    const handleSectionEditContent = (card, cardIndex, key, value) => {
        let c = [...(data?.emailContents || [])];
        c[cardIndex][key] = value
        if (props.onEdit) {
            props.onEdit('emailContents', c)
        }
    }
    {/*content handler*/ }


    const [isShowPreview, setisShowPreview] = useState(false);
    const [isShowSendPopup, setisShowSendPopup] = useState(false);
    const [isSendToAll, setisSendToAll] = useState(false);
    const [sendToEmailList, setsendToEmailList] = useState('');

    const handleSendEmail = async () => {

        if(!isSendToAll)
            for (let email of sendToEmailList.split(',')) {
                if (!validateEmail(email.trim())) {
                    alert(`無效的電郵地址: ${email.trim()}`);
                    return;
                }
            }

        setisloading(true);
        let res = await sendEmailTemplate(props.token, data?._id, sendToEmailList.split(',').map(email => email.trim()), [], isSendToAll || false);
        console.log(res);
        if (res.errno) {
            alert(res.message || '發送失敗');
            setisloading(false);
            return;
        } else {
            alert('發送成功');
        }
        // Implement the logic to send the email here
        setisloading(false);
        setisShowSendPopup(false);
    }

    const [isViewSentRecords, setisViewSentRecords] = useState(false);
    return (
        <div className="w-full h-full flex flex-col items-start justify-start bg-[#ddd] overflow-hidden p-[16px] gap-[8px]" style={{ overflowY: 'auto' }}>


            <div className='w-full flex flex-row justify-start items-start gap-[16px]'>
                <div onClick={() => { setisShowPreview(true) }} className="cursor-pointer hover:opacity-[.5] px-[24px] py-[4px] rounded-[4px] text-[white] font-[700] text-[12px]" style={{ background: 'linear-gradient(180deg, #7F7F7F 0%, rgba(96, 96, 96, 0.2) 100%)' }}>
                    預覽電郵
                </div>
                <div onClick={() => { setisShowSendPopup(true) }} className="cursor-pointer hover:opacity-[.5] px-[24px] py-[4px] rounded-[4px] text-[white] font-[700] text-[12px]" style={{ background: 'linear-gradient(180deg, #7F7F7F 0%, rgba(96, 96, 96, 0.2) 100%)' }}>
                    發送電郵
                </div>
                <div onClick={() => { setisViewSentRecords(!isViewSentRecords) }} className="cursor-pointer hover:opacity-[.5] px-[24px] py-[4px] rounded-[4px] text-[white] font-[700] text-[12px]" style={{ background: 'linear-gradient(180deg, #7F7F7F 0%, rgba(96, 96, 96, 0.2) 100%)' }}>
                    查看發送紀錄
                </div>
            </div>


            <ContentEditor
                isCmsEmail={true}
                data={data}
                field={'emailContents'}
                refresh={props.refresh}
                onDelete={handleSectionDeleteContent}
                onAddCard={handleAddContent}
                onEditKey={handleSectionEditContent}
                updateOrder={handleContentOrder}
            />


            {isShowPreview &&
                <div className="fixed top-0 left-0 right-0 bottom-0 z-[100] bg-[#00000080] flex items-center justify-center">
                    <div className="bg-[white] p-[16px] rounded-[7px] w-full max-w-[800px] relative max-h-[80vh] overflow-y-auto">
                        <div className="absolute top-0 right-0 p-[8px] cursor-pointer" onClick={() => { setisShowPreview(false) }}>
                            x
                        </div>

                        <div className='font-[700]'>電郵標題: {props.data?.email?.[props.type === 'register' ? 'registrationEmailTitle' : 'approvalEmailTitle'] || ''}</div>
                        <div className='font-[700] mt-[8px]'>電郵內容:</div>
                        <div className="bg-[#f0f0f0] text-[#6E604C]">
                            {props.data?.emailContents?.map((item, index) =>
                                <div key={index} className=" p-[8px] rounded-[4px] mb-[8px]">
                                    {item.type === '標題' && <div><h1 style={{ fontWeight: '700', }}>{item.data || ''}</h1></div>}
                                    {item.type === '電郵內容' && <div dangerouslySetInnerHTML={{ __html: item.data || '' }} />}
                                    {item.type === '圖片' && <img src={item.url} alt="Email Content" onClick={() => {
                                        if (item.allowUrlRedirect && item.redirectUrl) {
                                            window.open(item.redirectUrl, '_blank');
                                        }
                                    }} className="h-auto rounded-[4px] cursor-pointer" style={{ width: item.width || '100%' }} />}
                                </div>
                            )
                            }
                        </div>
                    </div>
                </div>
            }

            {isShowSendPopup &&
                <div className="fixed top-0 left-0 right-0 bottom-0 z-[100] bg-[#00000080] flex items-center justify-center">
                    <div className="bg-[white] p-[16px] rounded-[7px] w-full max-w-[800px] relative max-h-[80vh] overflow-y-auto">
                        <div className="absolute top-0 right-0 p-[8px] cursor-pointer" onClick={() => { setisShowSendPopup(false) }}>
                            x
                        </div>

                        <div className='font-[700]'>發送電郵</div>
                        {/*warning message: ask user to save the email template before sending*/}
                        <div className='mt-[8px] text-[red]'>*請先保存電郵模板，然後再發送</div>

                        <div className='mt-[8px] flex items-center gap-[8px]'>
                            <input type="checkbox" id="sendToAll" checked={isSendToAll} onChange={(e) => setisSendToAll(e.target.checked)} />
                            <label htmlFor="sendToAll">發送給所有人</label>
                        </div>

                        {isSendToAll === false && (
                            <>
                                <div className='mt-[8px]'>請輸入收件人電郵地址,使用逗號(,)分隔電子郵件地址<br/>(i.e: example1@example.com, example2@example.com):</div>
                                <textarea placeholder="收件人電郵地址, 使用逗號(,)分隔電子郵件地址 " className="w-full p-[8px] border-[1px] border-[#ccc] rounded-[4px]" value={sendToEmailList} onChange={(e) => setsendToEmailList(e.target.value)} />
                            </>
                        )}
                        <div className='mt-[8px]'>電郵主題:</div>
                        <div className="w-full p-[8px] border-[1px] border-[#ccc] rounded-[4px]">{data?.title || ''}</div>
                        <div className='mt-[8px] flex justify-end'>
                            <button className="bg-[#007BFF] text-white px-[16px] py-[8px] rounded-[4px]" onClick={handleSendEmail}>
                                發送
                            </button>
                        </div>
                    </div>
                </div>
            }
            {isViewSentRecords &&
                <div className="fixed top-0 left-0 right-0 bottom-0 z-[100] bg-[#00000080] flex items-center justify-center">
                    <div className="bg-[white] p-[16px] rounded-[7px] w-full max-w-[600px] relative max-h-[80vh] overflow-y-auto">
                        <div className="absolute top-0 right-0 p-[8px] cursor-pointer" onClick={() => { setisViewSentRecords(false) }}>
                            x
                        </div>

                        <div className='font-[700]'>發送紀錄</div>
                        {data?.sentRecords?.length > 0 ? (
                            <table className="w-full mt-[8px] border-collapse border border-[#ccc]">
                                <thead>
                                    <tr>
                                        <th className="border border-[#ccc] p-[4px]">發送時間</th>
                                        <th className="border border-[#ccc] p-[4px]">發送對象</th>
                                        {/* <th className="border border-[#ccc] p-[4px]">排除對象</th> */}
                                        <th className="border border-[#ccc] p-[4px]">總發送數量</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data?.sentRecords?.map((record, index) => (
                                        <tr key={index}>
                                            <td className="border border-[#ccc] p-[4px]">{new Date(record.sentAt).toLocaleString()}</td>
                                            <td className="border border-[#ccc] p-[4px]">{record.isAllUsers ? '所有人' : record.receiverEmails.join(', ').substring(0, 50)} {record.receiverEmails.join(', ').length > 50 ? '...' : ''}</td>
                                            {/* <td className="border border-[#ccc] p-[4px]">{record.excludeEmails.join(', ')}</td> */}
                                            <td className="border border-[#ccc] p-[4px]">{record.totalSent}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        ) : (
                            <div className='mt-[8px]'>暫無發送紀錄</div>
                        )}
                    </div>
                </div>
            }

            {isloading && <LoadingPage />}
        </div>
    )
}